/**
 * 取得頭像圖檔，主要用於判斷是否為兒童版頭像
 * @param {String} avatar avatar
 * @returns {Object} 圖檔路徑
 */
function getAvatarUrl(avatar) {
  let isKid = false;
  let isAnimate = false;
  let imgSrc = '';
  if (typeof avatar !== 'string' && avatar) {
    isKid = avatar.isKid;
    isAnimate = avatar.isAnimate;
    avatar = avatar.avatar;
  }
  if (isAnimate && isKid) {
    try {
      imgSrc = require(`@/assets/img/avatarAnimate/kid-${avatar}.webp`);
    } catch {
      imgSrc = '';
    }
  }
  if (isAnimate && !imgSrc) {
    try {
      imgSrc = require(`@/assets/img/avatarAnimate/${avatar}.webp`);
    } catch {
      imgSrc = '';
    }
  }
  if (isKid && !imgSrc) {
    try {
      imgSrc = require(`@/assets/img/avatar/kid-${avatar}.png`);
    } catch {
      imgSrc = '';
    }
  }
  if (!imgSrc) {
    try {
      imgSrc = require(`@/assets/img/avatar/${avatar}.png`);
    } catch {
      imgSrc = '';
    }
  }

  if (!imgSrc) {
    imgSrc = require('@/assets/img/avatar/none.png');
  }
  return imgSrc;
}

export default getAvatarUrl;
